import React, { useCallback } from 'react';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { useResolve } from '../../Container';
import { TextAlignment, TextSettings } from '../../canvas/entities/TextConventions';
import { UIField, UIFieldProps } from '../../canvas/entities/UIField';
import { PropertyStripLayout } from '../../canvas/properties/PropertyStripLayout';
import { fontColorSelector, fontFamilySelector, fontSizeSelector } from '../../canvas/properties/TextPropertyStripParts';
import { useComponentObserver } from '../../canvas/visualization/ComponentObserver';
import { SimpleTextFieldInput } from '../../canvas/workspace/adapters/SimpleTextFieldInput';
import { Zone } from './Zone';

const propertyLayout = PropertyStripLayout<Zone>((d, s, o, w, a) => {
    return [
        ...fontColorSelector('titleFontColor')(d, s, o, w, a),
        ...fontFamilySelector('titleFontFamily')(d, s, o, w, a),
        ...fontSizeSelector('titleFontSize')(d, s, o, w, a),
    ];
});

export const ZoneTitleFieldTextSettings = (zone: Zone) =>
    TextSettings.from({
        fontFamily: zone.titleFontFamily,
        fontColor: zone.titleFontColor,
        fontWeight: 450,
        fontSize: zone.titleFontSize,
        lineHeight: 1.25,
        textMargin: 5,
        fontStyle: 'normal',
        maxFontSize: null,
        textAlignH: TextAlignment.start,
        textAlignV: TextAlignment.start,
    });

export const ZoneTitleFieldEditor = ({ active, field }: UIFieldProps) => {

    const objects = useResolve(ObjectManager);
    const dispatch = useResolve(CommandDispatcher);
    const zone = field.owner.cast(Zone);
    useComponentObserver(zone);

    const onChange = useCallback((nextValue: string) => {
        objects.update(u => {
            u.rolling(UIField.key(field));
            zone.title = nextValue;
        });
    }, [field]);

    const onCommit = useCallback(() => {
        objects.update(u => u.noop());
    }, []);

    return <SimpleTextFieldInput {...{
        active,
        field,
        settings: ZoneTitleFieldTextSettings(zone),
        value: zone.title,
        onChange,
        onCommit,
    }} />;
};

export const ZoneTitleField = (owner: Zone): UIField => ({
    ui: ZoneTitleFieldEditor,
    name: 'title',
    bounds: owner.layout.title,
    owner,
    propertyLayout,
});
